import Cookies from "js-cookie";
import authType from "./authTypes";

export const logoutUserLocallyAction = (loginModalState = false) => {
  return (dispatch) => {
    dispatch({ type: authType["LOGOUT_USER"], payLoad: {} });
    // destroyLastLogin();
    Cookies.remove("token");
    Cookies.remove("user");
    Cookies.remove("team");
    Cookies.remove("outlet");
    localStorage.removeItem("undefined_reducer");
    window.location.reload(false);
  };
};
